import { render, staticRenderFns } from "./PortionReview.vue?vue&type=template&id=40d87b34&scoped=true&"
import script from "./PortionReview.vue?vue&type=script&lang=js&"
export * from "./PortionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d87b34",
  null
  
)

export default component.exports